(function(){
  const banner = document.querySelector("[id^='appBanner-']");
  
  if(!banner) return;

  const delay = parseInt(banner.dataset.delay, 10) * 1000 || 0;
  const frequency = parseInt(banner.dataset.frequency, 10) || 7; // days
  const storageKey = "appBannerDismissed-" + banner.id.replace("appBanner-", "");

  const getStored = () => {
    try { return JSON.parse(localStorage.getItem(storageKey)); }
    catch(e){ return null; }
  };

  const setStored = (days) => {
    const expires = Date.now() + (days * 864e5);
    localStorage.setItem(storageKey, JSON.stringify({ expires }));
  };

  const shouldShow = () => {
    const data = getStored();
    if(!data) return true;
    return Date.now() > data.expires;
  };

  const showBanner = () => {
    banner.style.display = "block";
  };

  const dismissBanner = () => {
    banner.style.display = "none";
    setStored(frequency);

    // Check if mobile menu is visible
    if (document.body.classList.contains("mobilemenu--isVisible")) {
      const mobileMenu = document.getElementById("mobilemenu");
      if (mobileMenu) {
        const currentTop = parseInt(window.getComputedStyle(mobileMenu).top, 10) || 0;
        mobileMenu.style.top = `${currentTop - 80}px`;
      }
    }
  };

  // Delay before showing
  if(shouldShow()){
    setTimeout(showBanner, delay);
  }

  // Close button
  const closeBtn = banner.querySelector(".app-banner__close"); 
  if(closeBtn){
    closeBtn.addEventListener("click", dismissBanner);
  }

  // CTA button
  const ctaBtn = banner.querySelector(".app-banner__cta a");
  if(ctaBtn){
    ctaBtn.addEventListener("click", dismissBanner);
  }
})();
